import { useMutation } from "@tanstack/react-query";
import { addOrUpdateTag, TagPayload } from "PFCore/services/activities/tags";
import { Id, MutationOptions } from "PFTypes";

import { useActivityInvalidate } from "../../activity";

type Payload = { activityId: Id; tagPayload: TagPayload };

export const useUpdateTag = (options: MutationOptions<Payload> = {}) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();

  return useMutation({
    mutationFn: ({ activityId, tagPayload }: Payload) => addOrUpdateTag(activityId, tagPayload),
    ...options,
    onSuccess: (...args) => {
      const { activityId } = args[1];

      invalidateActivity([activityId]);
      options?.onSuccess?.(...args);
    }
  });
};
